import React from 'react'

import Separator from '../../../../../components/pdf/Separator'
import Text from '../../../../../components/pdf/Text'
import View from '../../../../../components/pdf/View'

const CoverSection = () => (
  <View id="4">
    <Text bold size="small">
      4. FUNDAMENTAÇÃO LEGAL E TÉCNICA
    </Text>

    <ul>
      <li>
        <Text>Constituição Federal, Capítulo II (Dos Direitos Sociais), artigos 6º e 7º, inciso XXII;</Text>
      </li>

      <li>
        <Text>
          Condições previstas no subitem 17.1.1.1, das organizações e dos órgãos públicos da administração direta e
          indireta, bem como dos órgãos dos Poderes Legislativo, Judiciário e Ministério Público, que possuam empregados
          regidos pela Consolidação das Leis do Trabalho – CLT;
        </Text>
      </li>

      <li>
        <Text>Consolidação das Leis Trabalhistas – CLT – Artigos 166, 170, 171, 172, 174, 175, 178, 182, 183;</Text>
      </li>

      <li>
        <Text>
          NHO 11 (Norma de Higiene Ocupacional) – Avaliação dos níveis de iluminamento em ambientes internos de
          trabalho;
        </Text>
      </li>

      <li>
        <Text>ABNT NBR10.152:1992– Níveis de Ruído para conforto acústico;</Text>
      </li>

      <li>
        <Text>
          ABNT NBR 13966:2008 – Moveis para escritório – mesas – classificação e características físicas dimensionais e
          requisitos e métodos de ensaio NBR 10152:1992 - Níveis de Ruídos para Conforto Acústico;
        </Text>
      </li>

      <li>
        <Text>ABNT NBR 11228-1:2017 – Ergonomia – Parte 1: Levantamento e Transporte de Cargas;</Text>
      </li>

      <li>
        <Text>ABNT NBR 11228-2:2017 – Movimentação Manual – Parte 2: Empurrar e Puxar;</Text>
      </li>

      <li>
        <Text>
          ABNT NBR 11228-3:2017 – Movimentação Manual – Parte 3: Movimentação de Cargas Leves em alta frequência de
          repetitividade;
        </Text>
      </li>

      <li>
        <Text>
          Lei número 6.514, de 22 de dezembro de 1977 - Norma regulamentadora (NR) 17 Redação dada pela portaria
          no3.751, de 23-11-1990 (Ergonomia);
        </Text>
      </li>

      <li>
        <Text>ACGIH (American Conference of Governmental Industrial Hygienist) – TLVs e BEIs</Text>
      </li>

      <li>
        <Text>Pontos de Verificação Ergonômica –FUNDACENTRO.</Text>
      </li>
    </ul>

    <Separator weight={8} />
  </View>
)

export default CoverSection
